var React = require('react');

function IconOsO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M515.2 63.6c-247.4 0-448 200.6-448 448 0 164.5 88.6 308.2 220.7 386.1l28.5-57.8c-.1 0-.1-.1-.2-.1l85.4-172.5h.1l28.4-57.4c-29.3-23.5-48-59.5-48-99.9 0-70.7 57.3-128 128-128s128 57.3 128 128c0 38.3-16.8 72.6-43.4 96.1l31.5 55.7c.1-.1.2-.1.2-.2l97.3 172.2s-.1 0-.1.1l31.7 56c125-79.5 207.9-219.2 207.9-378.3 0-247.4-200.6-448-448-448zm259 731.1L671.3 612.5c18.9-29.6 29.8-64.8 29.8-102.5 0-105.5-85.5-191-191.1-191s-191 85.5-191 191.1c0 41.2 13 79.3 35.2 110.5l-89.9 181.5c-81.4-70.4-133-174.4-133-290.5 0-212 171.8-383.8 383.8-383.8S899 299.6 899 511.6c0 112.1-48.1 213-124.8 283.1z"}));
}

IconOsO.displayName = "IconOsO";

IconOsO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconOsO;

IconOsO.default = IconOsO;
